<div class="mt-6 w-full flex flex-col gap-5">
  <p-toast></p-toast>
  <p-confirmdialog />
  <p-card>
    <ng-template #title>
      <h1>{{ 'catalog.categories.title' | translate }}</h1>
    </ng-template>

    <div class="flex justify-end gap-2 mb-5">
      <p-button
        icon="fa fa-plus"
        [label]="'catalog.categories.add' | translate"
        (onClick)="openCreateDialog()"
      />
    </div>

    <p-table
      [value]="categoryService.categories()"
      stripedRows
      showGridlines
      dataKey="id"
      [paginator]="true"
      [rows]="25"
      [rowsPerPageOptions]="[25, 50, 75, 100]"
      sortField="title"
      [sortOrder]="1"
      [scrollable]="true"
      [tableStyle]="{ 'min-width': '40rem' }"
    >
      <ng-template #header>
        <tr>
          <th pSortableColumn="title">
            {{ 'catalog.categories.fields.title' | translate }}
            <p-sortIcon field="title" />
          </th>
          <th>{{ 'catalog.categories.fields.description' | translate }}</th>
          <th>{{ 'catalog.categories.fields.contingent' | translate }}</th>
          <th pFrozenColumn alignFrozen="right" class="w-32"></th>
        </tr>
      </ng-template>
      <ng-template #body let-row>
        <tr>
          <td>{{ row.title }}</td>
          <td class="max-w-md truncate">{{ row.description }}</td>
          <td>{{ contingentTitleFor(row.contingent_id) }}</td>
          <td pFrozenColumn alignFrozen="right">
            <div class="flex items-center justify-end gap-2">
              <button
                pButton
                type="button"
                icon="fa fa-pencil"
                text
                rounded
                severity="secondary"
                (click)="openEditDialog(row)"
              ></button>
              <button
                pButton
                type="button"
                icon="fa fa-trash"
                text
                rounded
                severity="secondary"
                (click)="onRowDelete($event, row)"
              ></button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template #emptymessage>
        <tr>
          <td colspan="4" class="text-center italic text-color-secondary py-6">
            {{ 'catalog.categories.empty' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>

  <p-dialog
    [header]="
      editing()
        ? ('catalog.categories.edit' | translate)
        : ('catalog.categories.add' | translate)
    "
    [modal]="true"
    [visible]="dialogVisible()"
    (visibleChange)="dialogVisible.set($event)"
    [closable]="!submitting()"
    [closeOnEscape]="!submitting()"
    [dismissableMask]="!submitting()"
    styleClass="w-[90vw] max-w-2xl"
    (onHide)="closeDialog()"
  >
    <form
      [formGroup]="form"
      (ngSubmit)="onSubmit()"
      class="flex flex-col gap-4"
    >
      <div class="flex flex-col">
        <label for="cat-title" class="text-sm mb-1">
          {{ 'catalog.categories.fields.title' | translate }}
        </label>
        <input
          id="cat-title"
          pInputText
          formControlName="title"
          [maxlength]="255"
        />
        @if (form.get('title')?.touched && form.get('title')?.invalid) {
          <small class="text-red-500 mt-1">
            {{ 'validation.required' | translate }}
          </small>
        }
      </div>

      <div class="flex flex-col">
        <label for="cat-desc" class="text-sm mb-1">
          {{ 'catalog.categories.fields.description' | translate }}
        </label>
        <textarea
          id="cat-desc"
          pTextarea
          formControlName="description"
          rows="3"
        ></textarea>
      </div>

      <div class="flex flex-col">
        <label for="cat-cont" class="text-sm mb-1">
          {{ 'catalog.categories.fields.contingent' | translate }}
        </label>
        <p-select
          inputId="cat-cont"
          formControlName="contingent_id"
          [options]="contingentService.contingents()"
          optionLabel="title"
          optionValue="id"
          [placeholder]="
            'catalog.categories.fields.contingentPlaceholder' | translate
          "
          appendTo="body"
        />
        @if (
          form.get('contingent_id')?.touched &&
          form.get('contingent_id')?.invalid
        ) {
          <small class="text-red-500 mt-1">
            {{ 'validation.required' | translate }}
          </small>
        }
      </div>

      <div class="flex justify-end gap-2 pt-2">
        <p-button
          type="button"
          severity="secondary"
          [label]="'label.cancel' | translate"
          [disabled]="submitting()"
          (onClick)="closeDialog()"
        />
        <p-button
          type="submit"
          [label]="'label.save' | translate"
          [loading]="submitting()"
        />
      </div>
    </form>
  </p-dialog>
</div>
